
namespace RioERP.Carts {

    @Serenity.Decorators.registerClass()
    export class CartProductSpecificationsGrid extends Serenity.EntityGrid<CartProductSpecificationsRow, any> {
        protected getColumnsKey() { return CartProductSpecificationsColumns.columnsKey; }
        protected getDialogType() { return CartProductSpecificationsDialog; }
        protected getIdProperty() { return CartProductSpecificationsRow.idProperty; }
        protected getInsertPermission() { return CartProductSpecificationsRow.insertPermission; }
        protected getLocalTextPrefix() { return CartProductSpecificationsRow.localTextPrefix; }
        protected getService() { return CartProductSpecificationsService.baseUrl; }

        constructor(container: JQuery) {
            super(container);
        }
    }
}